var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLanding',{attrs:{"faq-id":12},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_vm._v(_vm._s(_vm.$t('renew_header_car')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }